export class ShopDefinition {
	AgencyId: string;
	Id: string;

	constructor(agencyId: string, id: string) {
		this.AgencyId = agencyId;
		this.Id = id;
	}
}
